(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-button"] && !Shopify.designMode) return;
  try {
    // Configurator: width from the image's right edge to the viewport's
  // right edge (the options column), so the header's back button can sit
  // at the top right of the image.
  (function () {
    var button = document.querySelector('.back-button--configurator-header');
    var stage = document.querySelector('.configurator__stage');
    if (!button || !stage) return;

    function sync() {
      var right = Math.max(0, document.documentElement.clientWidth - stage.getBoundingClientRect().right);
      document.documentElement.style.setProperty('--configurator-options-width', right + 'px');
    }

    sync();
    window.addEventListener('resize', sync);
  })();

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-back-button]');
    if (!button || window.history.length < 2) return;
    event.preventDefault();
    window.history.back();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["idle-reset"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.querySelector('[data-idle-reset]');
    if (!dialog) return;

    if (new URLSearchParams(window.location.search).get('kiosk') !== '1') return;

    // Without the hash: a reload goes back to the top of the page.
    var startUrl = window.location.href.split('#')[0];

    var delay = (parseInt(dialog.dataset.delay, 10) || 60) * 1000;
    var countdown = parseInt(dialog.dataset.countdown, 10) || 15;
    var targetUrl = dialog.dataset.url || startUrl;
    var countLabel = dialog.querySelector('[data-idle-reset-count]');
    var idleTimer = null;
    var tickTimer = null;
    var remaining = 0;

    function startIdleTimer() {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(ask, delay);
    }

    function ask() {
      remaining = countdown;
      countLabel.textContent = remaining;
      if (!dialog.open) dialog.showModal();
      tickTimer = setInterval(function () {
        remaining -= 1;
        countLabel.textContent = Math.max(remaining, 0);
        if (remaining <= 0) {
          clearInterval(tickTimer);
          window.location.href = targetUrl;
        }
      }, 1000);
    }

    function stay() {
      clearInterval(tickTimer);
      if (dialog.open) dialog.close();
      startIdleTimer();
    }

    // Any activity restarts the wait — except while the pop-up is open:
    // there, only its button (or Escape) means "still here".
    function onActivity() {
      if (!dialog.open) startIdleTimer();
    }

    ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart', 'scroll'].forEach(function (type) {
      document.addEventListener(type, onActivity, { capture: true, passive: true });
    });

    dialog.querySelector('[data-idle-reset-stay]').addEventListener('click', stay);
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      stay();
    });

    startIdleTimer();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kilow-wordmark"] && !Shopify.designMode) return;
  try {
    (function () {
    // The word on its own — not inside a handle, address or domain
    // (@kilow.life, kilow.com, hello@kilow.fr): no "@", "." or letter
    // right before it, no "@" / letter / ".x" right after it. A sentence's
    // final dot ("chez KILOW.") still counts as the word on its own.
    var WORD = /(?<![\w@.])kilow(?![\w@]|\.\w)/i;
    var WORD_GLOBAL = /(?<![\w@.])kilow(?![\w@]|\.\w)/gi;
    // Text that must stay untouched (code, form values, page title…).
    var SKIP = 'script, style, noscript, template, textarea, input, select, option, title, code, pre, svg, [contenteditable], .kilow-word';

    function wrapTextNode(node) {
      var text = node.nodeValue;
      if (!WORD.test(text)) return;
      var parent = node.parentElement;
      if (!parent || parent.closest(SKIP)) return;

      var fragment = document.createDocumentFragment();
      var last = 0;
      text.replace(WORD_GLOBAL, function (match, index) {
        if (index > last) fragment.appendChild(document.createTextNode(text.slice(last, index)));
        var span = document.createElement('span');
        span.className = 'kilow-word';
        span.textContent = match;
        fragment.appendChild(span);
        last = index + match.length;
        return match;
      });
      if (last < text.length) fragment.appendChild(document.createTextNode(text.slice(last)));
      parent.replaceChild(fragment, node);
    }

    function wrapIn(root) {
      if (!root) return;
      if (root.nodeType === Node.TEXT_NODE) {
        wrapTextNode(root);
        return;
      }
      if (root.nodeType !== Node.ELEMENT_NODE || root.closest(SKIP)) return;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(wrapTextNode);
    }

    wrapIn(document.body);

    // Content added afterwards: cart updates, pop-ups filled on open,
    // theme editor reloads…
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(wrapIn);
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-pdf-viewer"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.querySelector('[data-lp-pdf]');
    if (!dialog) return;

    var frame = dialog.querySelector('[data-lp-pdf-frame]');
    var pageBox = dialog.querySelector('[data-lp-pdf-page]');
    var desktop = window.matchMedia('(min-width: 897px)');

    function showFrame(url) {
      pageBox.hidden = true;
      frame.hidden = false;
      frame.src = url;
      dialog.showModal();
    }

    function showPage(html) {
      frame.hidden = true;
      pageBox.hidden = false;
      pageBox.innerHTML = html;
      pageBox.scrollTop = 0;
      dialog.showModal();
    }

    // A store page (/pages/…) other than this one, only in ?menu=0 mode.
    function pageUrl(link) {
      if (!document.documentElement.classList.contains('menu-hidden')) return null;
      try {
        var url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin) return null;
        if (!/\/pages\/[^/]+\/?$/.test(url.pathname)) return null;
        if (url.pathname === window.location.pathname) return null;
        return url;
      } catch (error) {
        return null;
      }
    }

    function isPdf(link) {
      try {
        return /\.pdf$/i.test(new URL(link.href, window.location.href).pathname);
      } catch (error) {
        return false;
      }
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;

      if (isPdf(link) && desktop.matches) {
        event.preventDefault();
        showFrame(link.href);
        return;
      }

      var url = pageUrl(link);
      if (!url) return;
      event.preventDefault();
      // The page's own "main" section (sections/page.liquid, rendered as
      // #shopify-section-template--…__main). A page on another template
      // (e.g. a landing) has none: just go there.
      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var main = doc.querySelector('[id^="shopify-section-template--"][id$="__main"]');
          if (!main) throw new Error('no main section');
          showPage(main.innerHTML);
        })
        .catch(function () {
          window.location.href = link.href;
        });
    });

    dialog.querySelector('[data-lp-pdf-close]').addEventListener('click', function () {
      dialog.close();
    });

    // Click on the backdrop (outside the box) closes it.
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var rect = dialog.getBoundingClientRect();
      var inside =
        rect.top <= event.clientY && event.clientY <= rect.bottom && rect.left <= event.clientX && event.clientX <= rect.right;
      if (!inside) dialog.close();
    });

    // Unload the PDF / page once closed.
    dialog.addEventListener('close', function () {
      frame.removeAttribute('src');
      pageBox.innerHTML = '';
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    function initProductCardGallery(scope) {
    scope.querySelectorAll('[data-product-card-media]').forEach(function (media) {
      if (media.dataset.galleryBound) return;
      media.dataset.galleryBound = 'true';

      var gallery = media.closest('.product-card__gallery');
      var progress = gallery && gallery.querySelector('[data-product-card-progress]');
      var slides = Array.from(media.children);

      function setActive(index) {
        if (!progress) return;
        progress.querySelectorAll('[data-product-card-progress-index]').forEach(function (segment, i) {
          segment.classList.toggle('is-active', i === index);
        });
      }

      if (progress) {
        progress.querySelectorAll('[data-product-card-progress-index]').forEach(function (segment) {
          segment.addEventListener('click', function () {
            var index = Number(segment.dataset.productCardProgressIndex);
            var target = slides[index];
            if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
        });
      }

      if (slides.length > 1 && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) setActive(slides.indexOf(entry.target));
            });
          },
          { root: media, threshold: 0.6 }
        );

        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }
    });
  }

  initProductCardGallery(document);

  document.addEventListener('shopify:section:load', function (event) {
    initProductCardGallery(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-modal"] && !Shopify.designMode) return;
  try {
    var QUICK_ADD_COLOR_HEX = {
    noir: '#000000',
    black: '#000000',
    blanc: '#ffffff',
    white: '#ffffff',
    gris: '#9e9e9e',
    grey: '#9e9e9e',
    gray: '#9e9e9e',
    rouge: '#c0392b',
    red: '#c0392b',
    bleu: '#2f5aa8',
    blue: '#2f5aa8',
    vert: '#3e8e5a',
    green: '#3e8e5a',
    jaune: '#e8c547',
    yellow: '#e8c547',
    orange: '#e07b39',
    marron: '#6b4a35',
    brown: '#6b4a35',
    beige: '#d8c3a5',
    rose: '#e6a4c4',
    pink: '#e6a4c4',
    violet: '#7a5ea8',
    purple: '#7a5ea8',
    argent: '#c0c0c0',
    silver: '#c0c0c0',
    or: '#c9a227',
    gold: '#c9a227',
    kaki: '#7c7a4d',
    khaki: '#7c7a4d',
    bordeaux: '#6d1b2b',
    marine: '#1f2d4d',
    navy: '#1f2d4d'
  };

  function quickAddColorSwatch(name) {
    var key = (name || '').trim().toLowerCase();
    return QUICK_ADD_COLOR_HEX[key] || '#d9d9d9';
  }

  function quickAddFormatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function initQuickAddModal() {
    var modal = document.querySelector('[data-quick-add-modal]');
    if (!modal || modal.dataset.quickAddBound) return;
    modal.dataset.quickAddBound = 'true';

    var mediaEl = modal.querySelector('[data-quick-add-media]');
    var titleEl = modal.querySelector('[data-quick-add-title]');
    var colorsWrap = modal.querySelector('[data-quick-add-colors]');
    var colorValuesEl = modal.querySelector('[data-quick-add-color-values]');
    var addButton = modal.querySelector('[data-quick-add-add]');
    var addLabelEl = addButton.querySelector('[data-quick-add-add-label]');
    var addPriceEl = modal.querySelector('[data-quick-add-add-price]');
    var priceEl = modal.querySelector('[data-quick-add-price]');
    var detailsLink = modal.querySelector('[data-quick-add-details]');
    var errorEl = modal.querySelector('[data-quick-add-error]');
    var closeButton = modal.querySelector('[data-quick-add-close]');

    var state = { product: null, variant: null };

    function selectVariant(variant) {
      state.variant = variant;

      mediaEl.innerHTML = '';
      var imageSrc =
        (variant.featured_image && variant.featured_image.src) ||
        (state.product.images && state.product.images[0]);
      if (imageSrc) {
        var img = document.createElement('img');
        img.src = imageSrc;
        img.alt = state.product.title;
        mediaEl.appendChild(img);
      }

      addPriceEl.textContent = quickAddFormatPrice(variant.price);
      priceEl.textContent = quickAddFormatPrice(variant.price);
      addButton.disabled = !variant.available;
      addLabelEl.textContent = variant.available
        ? addButton.dataset.availableLabel
        : addButton.dataset.soldOutLabel;
    }

    function populate(product) {
      state.product = product;
      if (errorEl) errorEl.hidden = true;
      titleEl.textContent = product.title;
      detailsLink.href = product.url;
      colorValuesEl.innerHTML = '';

      var colorIndex = -1;
      (product.options || []).forEach(function (option, i) {
        // /products/{handle}.js returns options as {name, position, values}
        // objects, not plain strings.
        var normalized = ((option && option.name) || '').trim().toLowerCase();
        if (normalized === 'couleur' || normalized === 'color' || normalized === 'colour') {
          colorIndex = i;
        }
      });

      if (colorIndex > -1) {
        colorsWrap.hidden = false;
        var seen = {};

        product.variants.forEach(function (variant) {
          var value = variant['option' + (colorIndex + 1)];
          if (!value || seen[value]) return;
          seen[value] = true;

          var swatch = document.createElement('button');
          swatch.type = 'button';
          swatch.className = 'quick-add-modal__color-value';
          swatch.style.backgroundColor = quickAddColorSwatch(value);
          swatch.setAttribute('aria-label', value);

          swatch.addEventListener('click', function () {
            colorValuesEl.querySelectorAll('.quick-add-modal__color-value').forEach(function (el) {
              el.classList.remove('is-active');
            });
            swatch.classList.add('is-active');
            selectVariant(variant);
          });

          colorValuesEl.appendChild(swatch);
        });

        var firstSwatch = colorValuesEl.querySelector('.quick-add-modal__color-value');
        if (firstSwatch) firstSwatch.classList.add('is-active');
      } else {
        colorsWrap.hidden = true;
      }

      selectVariant(product.variants[0]);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-quick-add-trigger]');
      if (!trigger) return;

      var handle = trigger.dataset.productHandle;
      if (!handle) return;

      fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (product) {
          populate(product);
          modal.showModal();
        })
        .catch(function (error) {
          console.error('Quick add fetch failed', error);
        });
    });

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        modal.close();
      });
    }

    modal.addEventListener('click', function (event) {
      if (event.target !== modal) return;

      var rect = modal.getBoundingClientRect();
      var inside =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;

      if (!inside) modal.close();
    });

    addButton.addEventListener('click', function () {
      if (!state.variant) return;

      if (errorEl) errorEl.hidden = true;
      addButton.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: state.variant.id, quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (err) { throw err; });
          return response.json();
        })
        .then(function () {
          addButton.classList.add('is-added');
          addLabelEl.textContent = addButton.dataset.addedLabel;

          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = String((parseInt(el.textContent, 10) || 0) + 1);
          });

          // Held long enough to actually read the confirmation label
          // before the popup closes, not just flash past it.
          setTimeout(function () {
            // On the cart page itself (e.g. adding a recommended item
            // from the "Complétez votre achat" row), the item list and
            // summary panel wouldn't otherwise reflect the new line —
            // reloading is the simplest reliable way to show it, rather
            // than reimplementing cart.liquid's own refresh here.
            if (document.querySelector('[data-cart-root]')) {
              window.location.reload();
              return;
            }

            modal.close();
            addButton.classList.remove('is-added');
            addButton.disabled = false;
            addLabelEl.textContent = state.variant.available
              ? addButton.dataset.availableLabel
              : addButton.dataset.soldOutLabel;
          }, 900);
        })
        .catch(function (error) {
          console.error('Quick add to cart failed', error);
          if (errorEl) {
            errorEl.textContent = (error && error.description) || errorEl.dataset.genericError;
            errorEl.hidden = false;
          }
          addButton.disabled = false;
        });
    });
  }

  initQuickAddModal();
  } catch(e) { console.error(e); }
})();

})();
